import { CloseRounded } from '@mui/icons-material'
import { Button, DialogContent, DialogTitle, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import { StyledTabs } from '../../../../../../shared/components/StyledTabs'
import TabPanel from '../../../../../../shared/components/TabPanel'
import { CustomDialogActions } from '../../../../../../shared/components/modals/CustomDialogActions'
import useTabState from '../../../../../../shared/hooks/useTabState'
import { StyledDialog } from '../../../../../../shared/styles/StyledDialog'
import { CustomTab } from '../../modals/create/CustomTab'
import { AutocompleteBrandLinesVip } from './AutocompleteBrandLinesVip'
import { VipDateTimeRange } from './VipDateTimeRange'
import { VipTypesAutocomplete } from './VipTypesAutocomplete'

interface VipModalProps {
  open: boolean
  vipContentState: any
  handleClose: () => void
  tmpBrandLines: any
  handleInputChange: (inputName: string, value: any) => void
  handleSubmit: () => void
}

export function VipModal({ open, vipContentState, handleClose, tmpBrandLines, handleInputChange, handleSubmit }: VipModalProps) {
  const { t } = useTranslation(['global'])

  const { errorTab } = useSelector((state: IRootState) => state.validator)

  const { currentTab, setCurrentTab, a11yProps } = useTabState()

  return (
    <StyledDialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">{t('admin.people.assign')} VIP</Typography>
          <Button onClick={handleClose} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>

      <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
        <Grid xs={12}>
          <StyledTabs value={currentTab} onChange={(_: any, value: number) => setCurrentTab(value)} aria-label="vip user tabs">
            <CustomTab error={errorTab.general} label={t('general')} {...a11yProps(0)} />
          </StyledTabs>
        </Grid>

        <TabPanel value={currentTab} index={0}>
          <Grid container spacing={2}>
            {vipContentState.mode === 'brand' && (
              <Grid xs={12} sm={6} md={6}>
                <AutocompleteBrandLinesVip
                  vipContentState={vipContentState}
                  handleInputChange={handleInputChange}
                  tmpBrandLines={tmpBrandLines}
                />
              </Grid>
            )}

            <Grid xs={12} sm={6} md={6}>
              <VipTypesAutocomplete value={vipContentState.type} handleInputChange={handleInputChange} />
            </Grid>

            {vipContentState.type === 0 && (
              <VipDateTimeRange
                startDate={vipContentState.startDate}
                endDate={vipContentState.endDate}
                mode={vipContentState.mode}
                handleInputChange={handleInputChange}
              />
            )}
          </Grid>
        </TabPanel>
      </DialogContent>
      <CustomDialogActions handleSubmit={handleSubmit} handleClose={handleClose} />
    </StyledDialog>
  )
}
